export default {
    'shipping-advises': 'Avisos de embarque',
    'the-shipping-advice': 'es el Aviso de embarque?',
    'add-a-shipping-advice': 'Agregar aviso de embarque',
    'shipping-advise': 'Aviso de embarque',
    
    'item': 'Artículos'
}